import { FC, useEffect, useLayoutEffect } from 'react';

import Helmet from '@/components/meta/Helmet';
import GuideToretaTemplate from '@/components/templates/Guide/Toreta';
import { useSetBreadcrumbContext } from '@/contexts/breadcrumb';
import { useLayoutContext } from '@/contexts/layout';

import { GuidePageTitles } from '../types';

const GuideToretaPage: FC = () => {
  const { setLayoutStyles } = useLayoutContext();
  const setBreadcrumbs = useSetBreadcrumbContext();

  useEffect(() => {
    setBreadcrumbs([
      {
        name: 'ご利用ガイド',
        to: '/guide',
      },
      {
        name: 'toreta+ とは？',
        to: '',
      },
    ]);
  }, []);

  useLayoutEffect(() => {
    setLayoutStyles();
  }, []);

  return (
    <>
      <Helmet
        meta={{
          title: 'toreta+（トレタプラス）とは？',
          description:
            'DMM競輪のご利用ガイドページ。DMM競輪で投票を行う際に使用する専用の電子マネーtoreta+（トレタプラス）のチャージ方法をご案内します。',
          keywords: `${GuidePageTitles.Toreta},トレタプラス,ご利用ガイド,%s`,
        }}
      />
      <GuideToretaTemplate />
    </>
  );
};

export default GuideToretaPage;
